var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        title: _vm.$t("googleDrive.selectFile"),
        description: _vm.$t("googleDrive.selectFileFromGoogleDrive"),
        "class-name": "google-drive-picker-modal",
        okText: _vm.$t("googleDrive.upload"),
        cancelText: _vm.$t("message.cancel"),
        okDisabled: _vm.selectedFiles.length === 0 || _vm.uploading,
        okLoading: _vm.uploading,
      },
      on: { cancel: _vm.handleCancel, ok: _vm.handleConfirm },
    },
    [
      _c(
        "div",
        { staticClass: "google-drive-picker" },
        [
          _vm.uploading
            ? _c(
                "div",
                { staticClass: "upload-overlay" },
                [
                  _c("a-spin", { attrs: { size: "large" } }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("googleDrive.downloadingFiles"))),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "upload-progress" }, [
                    _vm._v(_vm._s(_vm.uploadProgress)),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.channels.length > 0
            ? _c(
                "div",
                { staticClass: "channel-selector" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("googleDrive.selectChannel"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      on: { change: _vm.onChannelChange },
                      model: {
                        value: _vm.selectedChannelId,
                        callback: function ($$v) {
                          _vm.selectedChannelId = $$v
                        },
                        expression: "selectedChannelId",
                      },
                    },
                    _vm._l(_vm.channels, function (channel) {
                      return _c(
                        "a-select-option",
                        { key: channel._id, attrs: { value: channel._id } },
                        [
                          _c(
                            "div",
                            { staticClass: "channel-option" },
                            [
                              _c("span", [_vm._v(_vm._s(channel.name))]),
                              _vm._v(" "),
                              _c("span", { staticClass: "channel-email" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      channel.payload && channel.payload.email
                                    ) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.isMyChannel(channel)
                                ? _c(
                                    "a-tag",
                                    { attrs: { color: "blue", size: "small" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("googleDrive.myChannel"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.channels.length === 0
            ? _c(
                "div",
                { staticClass: "no-channels" },
                [
                  _c("a-icon", { attrs: { type: "warning" } }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("googleDrive.noChannelsAvailable"))),
                  ]),
                ],
                1
              )
            : [
                _c(
                  "div",
                  { staticClass: "tabs" },
                  [
                    _c(
                      "a-radio-group",
                      {
                        attrs: { "button-style": "solid", size: "small" },
                        model: {
                          value: _vm.activeTab,
                          callback: function ($$v) {
                            _vm.activeTab = $$v
                          },
                          expression: "activeTab",
                        },
                      },
                      [
                        _c("a-radio-button", { attrs: { value: "myDrive" } }, [
                          _vm._v(_vm._s(_vm.$t("googleDrive.myDrive"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-radio-button",
                          { attrs: { value: "sharedDrives" } },
                          [_vm._v(_vm._s(_vm.$t("googleDrive.sharedDrives")))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("a-input-search", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        placeholder: _vm.$t("googleDrive.searchFiles"),
                        allowClear: "",
                        size: "small",
                      },
                      on: { search: _vm.handleSearch },
                      model: {
                        value: _vm.searchQuery,
                        callback: function ($$v) {
                          _vm.searchQuery = $$v
                        },
                        expression: "searchQuery",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.activeTab === "sharedDrives" && !_vm.selectedDriveId
                  ? _c("div", { staticClass: "shared-drives-list" }, [
                      _vm.loadingDrives
                        ? _c(
                            "div",
                            { staticClass: "loading" },
                            [_c("a-spin", { attrs: { size: "small" } })],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "drives-grid" },
                            [
                              _vm._l(_vm.sharedDrives, function (drive) {
                                return _c(
                                  "div",
                                  {
                                    key: drive.id,
                                    staticClass: "drive-card",
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectSharedDrive(drive)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", {
                                      staticClass: "drive-icon",
                                      attrs: { type: "folder" },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "drive-name" }, [
                                      _vm._v(_vm._s(drive.name)),
                                    ]),
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _vm.sharedDrives.length === 0
                                ? _c("div", { staticClass: "empty-state" }, [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("googleDrive.noSharedDrives")
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                    ])
                  : _c("div", { staticClass: "files-container" }, [
                      !_vm.isSearchMode
                        ? _c(
                            "div",
                            { staticClass: "breadcrumb-container" },
                            [
                              _c(
                                "a-breadcrumb",
                                [
                                  _c("a-breadcrumb-item", [
                                    _c(
                                      "a",
                                      { on: { click: _vm.navigateToRoot } },
                                      [
                                        _c("a-icon", {
                                          attrs: { type: "home" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.breadcrumbs, function (folder) {
                                    return _c(
                                      "a-breadcrumb-item",
                                      { key: folder.id },
                                      [
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.navigateToFolder(
                                                  folder.id,
                                                  folder.name
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(folder.name))]
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.loading
                        ? _c(
                            "div",
                            { staticClass: "loading" },
                            [_c("a-spin", { attrs: { size: "small" } })],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "files-grid" },
                            [
                              _vm._l(_vm.files, function (file) {
                                return _c(
                                  "div",
                                  {
                                    key: file.id,
                                    staticClass: "file-card",
                                    class: {
                                      selected: _vm.isSelected(file),
                                      folder: _vm.isFolder(file),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleFileClick($event, file)
                                      },
                                      dblclick: function ($event) {
                                        return _vm.handleFileDblClick(
                                          $event,
                                          file
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "file-icon" },
                                      [
                                        _vm.isFolder(file)
                                          ? _c("a-icon", {
                                              attrs: {
                                                type: "folder",
                                                theme: "filled",
                                              },
                                            })
                                          : file.thumbnailLink
                                          ? _c("img", {
                                              attrs: {
                                                src: file.thumbnailLink,
                                              },
                                            })
                                          : _c("a-icon", {
                                              attrs: {
                                                type: _vm.getFileIcon(
                                                  file.mimeType
                                                ),
                                              },
                                            }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "file-name",
                                        attrs: { title: file.name },
                                      },
                                      [_vm._v(_vm._s(file.name))]
                                    ),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm.files.length === 0 && !_vm.loading
                                ? _c("div", { staticClass: "empty-state" }, [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.$t("googleDrive.noFiles"))
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                      _vm._v(" "),
                      _vm.nextPageToken && !_vm.loading
                        ? _c(
                            "div",
                            { staticClass: "load-more" },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    size: "small",
                                    loading: _vm.loadingMore,
                                  },
                                  on: { click: _vm.loadMore },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("googleDrive.loadMore")) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                _vm._v(" "),
                _vm.selectedFiles.length > 0
                  ? _c("div", { staticClass: "selected-files" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("googleDrive.selectedFiles")) +
                            ": " +
                            _vm._s(_vm.selectedFiles.length)
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "selected-file-tags" },
                        _vm._l(_vm.selectedFiles, function (fileId) {
                          return _c(
                            "a-tag",
                            {
                              key: fileId,
                              attrs: { closable: "" },
                              on: {
                                close: function ($event) {
                                  return _vm.removeSelection(fileId)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.getFileName(fileId)) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ])
                  : _vm._e(),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("FilePreviewModal", {
        attrs: {
          visible: _vm.previewVisible,
          files: _vm.previewableFiles,
          "initial-index": _vm.previewIndex,
          "channel-id": _vm.selectedChannelId,
        },
        on: { close: _vm.closePreview, downloaded: _vm.onFileDownloaded },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }